import { PageHeader } from '@/components/PageHeader'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/settings/integrations')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="container px-8 py-8 mx-auto max-w-5xl">
      <PageHeader
        title="Integrations"
        description="Manage your integrations"
        className="mb-8"
      ></PageHeader>
      <Outlet />
    </div>
  )
}
